export default function Sticker({ sticker }) {
    return <div style={{ backgroundImage: `url(${sticker})`, width: "5rem", height: "5rem", backgroundRepeat: "no-repeat", backgroundSize: "contain", marginLeft: "0.3rem" }}></div>

}